import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import {
  ToolbarModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  TableModule,
} from 'beyond-util';
import { TipoviKorekcijaComponent } from './tipovi-korekcija.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
  ],
  declarations: [TipoviKorekcijaComponent],
  entryComponents: [TipoviKorekcijaComponent],
  exports: [TipoviKorekcijaComponent],
})
export class TipoviKorekcijaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/tipovi-korekcija/tipovi-korekcija.module.ts